import { useEffect, useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { fetchPublicStaticPage } from '@/services/staticPages';

const fallbackContent = `
  <h2>一、會員資格</h2>
  <p>凡透過富聆聽健康官方網站完成註冊程序，並提供真實、正確、完整之個人資料者，即成為本網站會員。會員應對所提供資料之真實性負責，如有變更應即時更新。</p>
  <h2>二、帳號與密碼</h2>
  <p>會員應妥善保管帳號及密碼，不得轉讓或提供予第三人使用。若發現帳號遭盜用或有安全疑慮，請立即與客服聯繫並修改密碼，本公司對於因會員保管不當所致之損失不負賠償責任。</p>
  <h2>三、個人資料之蒐集與使用</h2>
  <p>本公司依據個人資料保護法蒐集會員之姓名、性別、生日、聯絡方式及地址等資料，僅用於會員服務、訂單處理、客服聯繫及行銷推廣等目的，未經會員同意不會提供予無關第三人。</p>
  <h2>四、訂單與交易</h2>
  <p>會員於本網站下單購買商品，即視為同意本網站之購物流程、付款方式及退換貨規範。訂單成立後，本公司將依約定方式出貨，付款方式與到貨時間請參閱各商品頁面說明。</p>
  <h2>五、會員義務</h2>
  <p>會員不得利用本網站從事任何違反法令、公共秩序或善良風俗之行為，亦不得冒用他人資料進行註冊或下單。如有違反，本公司得暫停或終止其會員資格。</p>
  <h2>六、條款修改</h2>
  <p>本公司保留隨時修改本會員條款之權利，修改後之條款將公告於本網站，會員如於公告後繼續使用本網站服務，視為同意修改後之條款內容。</p>
`;

export default function Terms() {
  const [title, setTitle] = useState('會員條款');
  const [content, setContent] = useState(fallbackContent);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    fetchPublicStaticPage('member-terms').then((data) => {
      if (!alive) return;
      if (data) {
        setTitle(data.title || '會員條款');
        setContent(data.content || fallbackContent);
      }
      setLoading(false);
    });
    return () => {
      alive = false;
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-20 md:pt-24">
        <div className="mx-auto max-w-3xl px-6 py-12 md:py-20">
          <div className="mb-8 text-center">
            <span className="inline-block text-xs font-semibold tracking-widest text-[#D4A574] uppercase mb-2">
              Terms of Membership
            </span>
            <h1 className="text-2xl md:text-3xl font-bold text-[#1B3D2A]">{title}</h1>
          </div>

          {loading ? (
            <div className="space-y-4 rounded-2xl border border-[#E8E0D6] bg-[#FAF8F5] p-6 md:p-8">
              <div className="h-4 w-1/3 animate-pulse rounded bg-white" />
              <div className="h-4 animate-pulse rounded bg-white" />
              <div className="h-4 w-5/6 animate-pulse rounded bg-white" />
            </div>
          ) : (
            <div
              className="prose max-w-none rounded-2xl border border-[#E8E0D6] bg-[#FAF8F5] p-6 text-sm leading-relaxed text-[#5A6B5A] prose-headings:text-base prose-headings:font-bold prose-headings:text-[#1B3D2A] prose-p:text-[#5A6B5A] md:p-8"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
